import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "dth-main" };
const _hoisted_2 = { class: "dth-inner container size--wide" };
const _hoisted_3 = { class: "dth-top" };
const _hoisted_4 = ["href"];
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "dth-bottom" };
const _hoisted_7 = ["id"];
const _hoisted_8 = ["id", "aria-controls", "aria-owns", "aria-checked", "aria-label", "onClick"];
const _hoisted_9 = { class: "dth-inputField" };
const _hoisted_10 = {
    key: 0,
    class: "dth-panelWrapper"
};
const _hoisted_11 = ["id"];
const _hoisted_12 = { class: "dth-panelInner" };
const _hoisted_13 = ["id", "aria-labelledby"];
const _hoisted_14 = { class: "dth-panelInner" };
import { ThemeIcon, ThemeButton } from '../../../front/components';
import { ref, onUnmounted, onMounted, watch, nextTick } from 'vue';
import { trapFocusInsideContainer } from '../../../front/lib/utils';
import Cell from './Cell.vue';
import { theme } from '../../../front/Theme';
import SiteSearch from '../../../front/components/SiteSearch/SiteSearch.vue';
import { freezeWindowScroll, unfreezeWindowScroll } from '../../../front/shared';
import { Search } from '../../../layouts/Search/Search';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopHeader',
    props: {
        siteHeader: {}
    },
    emits: {
        showLogin: null,
    },
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const json = props.siteHeader.json;
        const menu = json.menu;
        const panelWrapperInnerEl = ref();
        const menuBarEl = ref();
        const searchInputWrapperEl = ref();
        const searchQueryInputEl = ref();
        const searchPanelEl = ref();
        const menuItemPanelEl = ref();
        const menuItemButtons = ref([]);
        const menuActive = ref(false);
        const activeMenuItem = ref();
        const searchActive = ref(false);
        const searchQuery = ref('');
        const emit = __emit;
        __expose({
            canDuck,
        });
        onMounted(() => {
            document.addEventListener('click', onDocumentClick);
        });
        onUnmounted(() => {
            document.removeEventListener('click', onDocumentClick);
        });
        watch(searchActive, value => {
            if (value) {
                nextTick(captureFocusInsideSearchPanel);
            }
        });
        watch(activeMenuItem, value => {
            if (value) {
                nextTick(captureFocusInsideMenuItemPanel);
            }
        });
        watch(searchQuery, (value) => {
            if (value.length) {
                showSearch();
            }
        });
        function emptySearchQuery(event) {
            var _a;
            searchQuery.value = '';
            (_a = searchQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            if (event.cancelable) {
                event.stopPropagation();
            }
        }
        function isMenuItemActive(menuItem) {
            var _a;
            return ((_a = activeMenuItem.value) === null || _a === void 0 ? void 0 : _a.entry.id) === menuItem.entry.id;
        }
        function toggleMenuItem(menuItem) {
            return isMenuItemActive(menuItem) ? hideActiveMenuItem() : showMenuItem(menuItem);
        }
        function showMenuItem(menuItem) {
            var _a;
            if (((_a = activeMenuItem.value) === null || _a === void 0 ? void 0 : _a.entry.id) === menuItem.entry.id) {
                return;
            }
            hideSearch();
            activeMenuItem.value = menuItem;
        }
        function hideActiveMenuItem() {
            if (!activeMenuItem.value) {
                return;
            }
            activeMenuItem.value = null;
        }
        function hideSearch() {
            searchActive.value = false;
            unfreezeWindowScroll();
        }
        function showSearch() {
            searchActive.value = true;
            freezeWindowScroll();
        }
        function toggleSearch() {
            return searchActive.value ? hideSearch() : showSearch();
        }
        function canDuck() {
            return !menuActive.value && !searchActive.value && !activeMenuItem.value;
        }
        function maybeNavigateToSearchPage() {
            const query = searchQuery.value.trim();
            if (query) {
                const url = Search.buildUrl({ query });
                window.location.href = url.toString();
            }
        }
        function captureFocusInsideMenuItemPanel() {
            const panel = menuItemPanelEl.value;
            if (panel) {
                const handler = trapFocusInsideContainer(panel);
                handler.enter();
                handler.waitForEscape().then(() => {
                    var _a, _b;
                    hideActiveMenuItem();
                    (_b = (_a = menuItemButtons.value) === null || _a === void 0 ? void 0 : _a.find(el => el.classList.contains('is--active'))) === null || _b === void 0 ? void 0 : _b.focus();
                });
            }
        }
        function captureFocusInsideSearchPanel() {
            const panel = searchPanelEl.value;
            if (panel) {
                const handler = trapFocusInsideContainer(panel);
                handler.waitForEscape().then(() => {
                    var _a;
                    hideSearch();
                    (_a = searchQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        }
        function onDocumentClick(event) {
            var _a, _b, _c;
            if (activeMenuItem.value || searchActive.value) {
                const target = event.target;
                // Detect outside click
                if (!target.closest('.themeModal') && !((_a = menuBarEl.value) === null || _a === void 0 ? void 0 : _a.contains(target)) && !((_b = panelWrapperInnerEl.value) === null || _b === void 0 ? void 0 : _b.contains(target))) {
                    if (searchActive.value && target.parentElement && !((_c = searchInputWrapperEl.value) === null || _c === void 0 ? void 0 : _c.contains(target))) {
                        hideSearch();
                    }
                    else if (activeMenuItem.value) {
                        hideActiveMenuItem();
                    }
                }
            }
        }
        function onBeforePanelEnter(el) {
            // We're forced to use `before-enter` event instead of `enter` event
            // since `enter` event required to be explicitly completed, and not doing so won't trigger `after-enter` event
            window.requestAnimationFrame(() => {
                // Wait at least 1 frame until element is inserted into the DOM.
                const innerEl = el.querySelector('.dth-panelInner');
                if (innerEl && panelWrapperInnerEl.value) {
                    panelWrapperInnerEl.value.style.height = searchActive.value ? '100%' : (innerEl.scrollHeight + 'px');
                }
            });
        }
        let prevMenuItemState = activeMenuItem.value;
        function onAfterPanelEnter(el) {
            // Cleanup height to allow it to be adjusted automatically on resize/orientationchange
            if (!prevMenuItemState) {
                prevMenuItemState = activeMenuItem.value;
                return;
            }
            prevMenuItemState = activeMenuItem.value;
            if (panelWrapperInnerEl.value) {
                panelWrapperInnerEl.value.style.height = '';
            }
        }
        function onBeforePanelLeave(el) {
            // Set height explicitly again before next transition
            const innerEl = el.querySelector('.dth-panelInner');
            if (innerEl && panelWrapperInnerEl.value) {
                panelWrapperInnerEl.value.style.height = innerEl.scrollHeight + 'px';
            }
        }
        function onBeforePanelWrapperLeave(el) {
            // Set height explicitly again before next transition
            const innerEl = el.querySelector('.dth-panelInner');
            const panelWrapperInnerEl = el.querySelector('.dth-panelWrapper-inner');
            if (innerEl && panelWrapperInnerEl) {
                panelWrapperInnerEl.style.height = innerEl.scrollHeight + 'px';
            }
            prevMenuItemState = activeMenuItem.value;
        }
        function onSearchInputFocus() {
            hideActiveMenuItem();
            showSearch();
        }
        function onSearchInputFocusOut(event) {
            // TODO Use focusout event, since it bubbles up
            if (event.relatedTarget) {
                hideSearch();
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("a", {
                                class: "dth-logo",
                                href: _unref(json).homeUrl,
                                "aria-label": "Skolporten hemsida"
                            }, [
                                _createElementVNode("img", {
                                    src: _unref(theme)().getUri('assets/images/skolporten-logo-primary.svg'),
                                    alt: "Skolporten logo"
                                }, null, 8, _hoisted_5)
                            ], 8, _hoisted_4),
                            _createVNode(_unref(ThemeButton), {
                                title: "Logga in",
                                icon: "login",
                                color: "dark",
                                fill: "outline",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('showLogin')))
                            })
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", {
                                role: "menubar",
                                class: "dth-menuBar",
                                id: _ctx.siteHeader.makeId('menuBar'),
                                "aria-label": "Huvudmeny",
                                ref_key: "menuBarEl",
                                ref: menuBarEl
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (menuItem) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        role: "menuitemradio",
                                        key: _ctx.siteHeader.makeId(`menuitem-${menuItem.entry.id}`),
                                        id: _ctx.siteHeader.makeId(`menuitem-${menuItem.entry.id}`),
                                        class: _normalizeClass(["dth-menuItem", {
                                                'is--active': isMenuItemActive(menuItem),
                                                [`is--${menuItem.entry.locationRelation}`]: menuItem.entry.locationRelation
                                            }]),
                                        "aria-controls": _ctx.siteHeader.makeId(`panel-${menuItem.entry.id}`),
                                        "aria-owns": _ctx.siteHeader.makeId(`panel-${menuItem.entry.id}`),
                                        "aria-checked": isMenuItemActive(menuItem),
                                        "aria-haspopup": "true",
                                        "aria-label": menuItem.entry.title,
                                        ref_for: true,
                                        ref_key: "menuItemButtons",
                                        ref: menuItemButtons,
                                        onClick: ($event) => (toggleMenuItem(menuItem))
                                    }, [
                                        _createElementVNode("span", null, [
                                            _createElementVNode("span", null, _toDisplayString(menuItem.entry.title), 1),
                                            _createVNode(_unref(ThemeIcon), { name: "chevron-right" })
                                        ])
                                    ], 10, _hoisted_8));
                                }), 128))
                            ], 8, _hoisted_7),
                            _createElementVNode("div", {
                                class: _normalizeClass(["dth-searchInputWrapper", { 'is--active': searchActive.value }]),
                                ref_key: "searchInputWrapperEl",
                                ref: searchInputWrapperEl
                            }, [
                                _createElementVNode("label", _hoisted_9, [
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "screen-reader-text" }, "Sök här…", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "dth-inputField-input",
                                        placeholder: "Sök här…",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                        ref_key: "searchQueryInputEl",
                                        ref: searchQueryInputEl,
                                        onFocus: onSearchInputFocus,
                                        onKeydown: [
                                            _cache[2] || (_cache[2] = _withKeys(($event) => (hideSearch()), ["esc"])),
                                            _cache[3] || (_cache[3] = _withKeys(($event) => (maybeNavigateToSearchPage()), ["enter"]))
                                        ]
                                    }, null, 544), [
                                        [_vModelText, searchQuery.value]
                                    ]),
                                    _createVNode(_unref(ThemeIcon), {
                                        class: "dth-inputField-icon",
                                        name: "magnifying-glass"
                                    }),
                                    (searchQuery.value)
                                        ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                            key: 0,
                                            class: "dth-inputField-emptyBtn",
                                            "wca-title": "Empty search",
                                            icon: "times-round-outline",
                                            color: "primary",
                                            fill: "none",
                                            size: "small",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (emptySearchQuery($event)))
                                        }))
                                        : _createCommentVNode("", true)
                                ])
                            ], 2)
                        ])
                    ])
                ]),
                _createVNode(_Transition, {
                    name: "wrapper",
                    onAfterEnter: onAfterPanelEnter,
                    onBeforeLeave: onBeforePanelWrapperLeave
                }, {
                    default: _withCtx(() => [
                        (searchActive.value || activeMenuItem.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", {
                                    class: "dth-panelWrapper-inner",
                                    ref_key: "panelWrapperInnerEl",
                                    ref: panelWrapperInnerEl
                                }, [
                                    _createVNode(_Transition, {
                                        name: "panel",
                                        onBeforeEnter: onBeforePanelEnter,
                                        onAfterEnter: onAfterPanelEnter,
                                        onBeforeLeave: onBeforePanelLeave,
                                        appear: ""
                                    }, {
                                        default: _withCtx(() => [
                                            (searchActive.value)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    role: "presentation",
                                                    id: _ctx.siteHeader.makeId(`panel-search`),
                                                    class: "dth-panel dth-searchPanel",
                                                    "aria-label": "Sök resultat",
                                                    ref_key: "searchPanelEl",
                                                    ref: searchPanelEl,
                                                    onKeydown: _withKeys(hideSearch, ["esc"])
                                                }, [
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createVNode(SiteSearch, {
                                                            query: searchQuery.value,
                                                            "link-to-search-page": true,
                                                            "without-input": true
                                                        }, null, 8, ["query"])
                                                    ])
                                                ], 40, _hoisted_11))
                                                : (activeMenuItem.value)
                                                    ? (_openBlock(), _createElementBlock("nav", {
                                                        key: activeMenuItem.value.entry.id,
                                                        id: _ctx.siteHeader.makeId(`panel-${activeMenuItem.value.entry.id}`),
                                                        class: "dth-panel dth-menuPanel",
                                                        "aria-labelledby": _ctx.siteHeader.makeId(`menuItem-${activeMenuItem.value.entry.id}`),
                                                        ref_key: "menuItemPanelEl",
                                                        ref: menuItemPanelEl
                                                    }, [
                                                        _createElementVNode("div", _hoisted_14, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeMenuItem.value.cells, (cell, cidx) => {
                                                                return (_openBlock(), _createBlock(Cell, {
                                                                    key: activeMenuItem.value.entry.id.toString() + cidx,
                                                                    cell: cell
                                                                }, null, 8, ["cell"]));
                                                            }), 128))
                                                        ])
                                                    ], 8, _hoisted_13))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    })
                                ], 512)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
